import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; // Still useful for initial detection and caching

import enTranslations from './languages/en.json'; // English
import arTranslations from './languages/ar.json'; // Arabic
import esTranslations from './languages/es.json'; // Spanish
import koTranslations from './languages/ko.json'; // Korean
import frTranslations from './languages/fr.json'; // French
import deTranslations from './languages/de.json'; // German

// This function determines the initial language based on your business logic.
// It prioritizes the 'req_language' cookie.
const getPrioritizedInitialLanguage = () => {
    const currentHost = window.location.host;

    // Determine the client type based on the host first
    let clientType = 'en-only'; // Default to 'en-only'

    if (clientConfig['en-ar-only'].some((host) => currentHost.includes(host))) {
        clientType = 'en-ar-only';
    } else if (
        clientConfig['all-languages'].some((host) => currentHost.includes(host))
    ) {
        clientType = 'all-languages';
    }

    // Define the allowed languages for the current client type
    let allowedLanguages;
    if (clientType === 'en-only') {
        allowedLanguages = ['en'];
    } else if (clientType === 'en-ar-only') {
        allowedLanguages = ['en', 'ar'];
    } else {
        // clientType === 'all-languages'
        allowedLanguages = Object.keys(resources);
    }

    // 1. Check for 'req_language' cookie
    const reqLanguageCookie = document.cookie
        .split('; ')
        .find((row) => row.startsWith('req_language='));
    if (reqLanguageCookie) {
        const lang = reqLanguageCookie.split('=')[1];
        if (allowedLanguages.includes(lang)) {
            // Check if cookie language is allowed
            return lang;
        }
    }

    // 2. Fallback to browser navigator language
    if (navigator.language) {
        const browserLang = navigator.language.split('-')[0];
        if (allowedLanguages.includes(browserLang)) {
            // Check if browser language is allowed
            return browserLang;
        }
    }

    // 3. Ultimate default: 'en' for all cases if no valid language was found through detection
    // (This is implicitly 'en' because 'en' is always in the allowedLanguages for all types)
    return 'en';
};

const resources = {
    en: {
        translation: enTranslations
    },
    ar: {
        translation: arTranslations
    },
    es: {
        translation: esTranslations
    },
    ko: {
        translation: koTranslations
    },
    fr: {
        translation: frTranslations
    },
    de: {
        translation: deTranslations
    }
};
const i18nInstance = i18n.createInstance();

// Define client type mappings based on hostname.
// If a host is not listed here, it implicitly falls into the 'en-only' category.
const clientConfig = {
    // Clients which can use English and Arabic
    'en-ar-only': ['www.spl.com.sa', 'web.saudi-pro-league.test.pulselive.com'],
    // Clients which we translate it all (all supported languages)
    'all-languages': [
        'test.wta.pulselive.com',
        'localhost:9001',
        'wr.staging.pulselive.com'
    ]
};

const langBehaviour = getPrioritizedInitialLanguage();

i18nInstance
    .use(LanguageDetector) // Still useful for initial detection and caching in a cookie
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        resources,
        detection: {
            order: ['cookie', 'navigator'], // Order of preference for detection
            lookupCookie: 'req_language', // Your specific cookie name
            cookieOptions: {
                path: '/',
                sameSite: 'Lax',
                secure: process.env.NODE_ENV === 'production' // Use secure flag in production
            }
        },
        supportedLngs: Object.keys(resources),
        lng: langBehaviour,
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });
export default i18nInstance;
